import { render, staticRenderFns } from "./szItem.vue?vue&type=template&id=acad1176&scoped=true&"
import script from "./szItem.vue?vue&type=script&lang=js&"
export * from "./szItem.vue?vue&type=script&lang=js&"
import style0 from "./szItem.vue?vue&type=style&index=0&id=acad1176&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "acad1176",
  null
  
)

export default component.exports